import KeyboardForVue from './KeyboardForVue'

function install (Vue) {
  Vue.component(KeyboardForVue.name, KeyboardForVue)
}

export default install
